"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = Box;
var _react = _interopRequireDefault(require("react"));
var _styled = require("../../styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `Box` component is base-level component that can be used to set backgrounds, borders, and
 * padding.
 */
function Box({
  bg,
  className,
  css: cssProps,
  testId,
  ...props
}) {
  const propStyles = (0, _styled.css)({
    backgroundColor: bg
  });
  return /*#__PURE__*/_react.default.createElement(_styled2.StyledBox, _extends({
    className: `${propStyles()} ${className}`,
    css: cssProps,
    "data-testid": testId
  }, props));
}